import React, { useState } from 'react';
import Modal from '../../components/layout/Modal';
import VBox from '../../components/layout/VBox';
import HBox from '../../components/layout/HBox';
import Grid, { GridItem } from '../../components/layout/Grid';
import Tabs from '../../components/layout/Tabs';
import { DialogoTemplate } from '@tera/shared/src/types/DialogoTemplate';
import { dialogoTemplateCategories } from '@tera/shared/src/dialogoTemplates';
import styles from './ModalTemplateSelector.module.css';
import Icon from '@/components/Icon';
import {
    mdiRobot,
    mdiHandshake,
    mdiLifebuoy,
    mdiShape,
    mdiCheck,
} from '@mdi/js';

interface ModalTemplateSelectorProps {
    show: boolean;
    onClose: () => void;
    onSelectTemplate: (template: DialogoTemplate) => void;
}

const categoryIcons: Record<string, string> = {
    geral: mdiShape,
    atendimento: mdiRobot,
    vendas: mdiHandshake,
    suporte: mdiLifebuoy,
};

export const ModalTemplateSelector: React.FC<ModalTemplateSelectorProps> = ({
    show,
    onClose,
    onSelectTemplate,
}) => {
    const [selectedCategory, setSelectedCategory] = useState('geral');
    const [selectedTemplate, setSelectedTemplate] = useState<DialogoTemplate | null>(null);

    const currentCategory = dialogoTemplateCategories.find(
        cat => cat.id === selectedCategory,
    );

    const handleSelectTemplate = (template: DialogoTemplate) => {
        setSelectedTemplate(template);
    };

    const handleConfirm = () => {
        if (selectedTemplate) {
            onSelectTemplate(selectedTemplate);
            onClose();
        }
    };

    const handleCancel = () => {
        setSelectedTemplate(null);
        onClose();
    };

    return (
        <Modal
            instanceId="modal-template-selector"
            show={show}
            onClose={handleCancel}
            onCancel={handleCancel}
            onConfirm={handleConfirm}
            size="lg"
            title="Escolher template de fluxo"
            confirmProps={{
                label: 'Usar template',
                disabled: !selectedTemplate,
            }}
            cancelProps={{
                label: 'Cancelar',
            }}
        >
            <VBox gap="24px">
                <div>
                    <p style={{ marginBottom: '16px', color: 'var(--tc-color-gray-600)' }}>
                        Escolha um template para começar seu fluxo de atendimento mais rapidamente.
                    </p>
                </div>

                <Tabs
                    size="lg"
                    tabs={dialogoTemplateCategories.map(cat => ({
                        id: cat.id,
                        label: cat.label,
                        icon: categoryIcons[cat.id],
                    }))}
                    selectedTab={selectedCategory}
                    onTabChange={setSelectedCategory}
                />

                <Grid>
                    {currentCategory?.templates.map(template => (
                        <GridItem key={template.id} sm={12} md={6}>
                            <div
                                className={`${styles.templateCard} ${selectedTemplate?.id === template.id ? styles.selected : ''
                                    }`}
                                onClick={() => handleSelectTemplate(template)}
                            >
                                <HBox className={styles.templateHeader}>
                                    <div className={styles.templateTitle}>
                                        {template.nome}
                                    </div>
                                    {selectedTemplate?.id === template.id && (
                                        <div className={styles.checkIcon}>
                                            <Icon path={mdiCheck} size={0.8} />
                                        </div>
                                    )}
                                </HBox>
                                <p className={styles.templateDescription}>
                                    {template.descricao}
                                </p>
                            </div>
                        </GridItem>
                    ))}
                </Grid>
            </VBox>
        </Modal>
    );
};
